import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AssessmentBannerSlot"] */ "/vercel/path0/src/components/assessment/AssessmentBannerSlot.tsx");
